import React from 'react';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';

const Js = () => {
  return (
    <>
      <Paragraph>
        I don’t think of myself as a JavaScript expert, as Kyle Simpson
        simply put it <Accent>“You don’t know Javascript”</Accent>, but frankly
        I think I know <Accent>"enough to be dangerous"</Accent>. I keep coming
        back to the O&apos;Reilly JS bible (yes, the one with the rhino) when I
        feel I need to refresh or deepen some of my knowledge. I actually can’t
        think of a better way to fall asleep.
      </Paragraph>
      <Paragraph>
        I certainly adopted the <Accent>ES6 syntax</Accent> and I incline to the{' '}
        <Accent>functional programming</Accent> pattern, which goes well with
        the use of <Accent>React</Accent>. Framework that I have been using for the last 5 years
        and that I’ve chosen for its <Accent>declarative approach</Accent>, its
        modularity and its dynamic ecosystem and community.
      </Paragraph>{' '}
      <Paragraph>
        <Accent>Wes Bos, Kent C. Dodds</Accent> are currently my main sources of
        inspiration and learning and I warmly recommend the{' '}
        <a href="https://syntax.fm" title="Syntax podcast">
          Syntax podcast.
        </a>
      </Paragraph>
    </>
  );
};

Js.propTypes = {};

export default Js;
